import styles from './description.module.scss';
import cs from 'classnames';
import { useTranslation, Trans } from 'react-i18next';
import { replaceWithBr } from '../../../../utils/replace-with-br';
import { useLocation } from 'react-router-dom';

const currentDate = new Date();

const copyright = `© Adwile Ltd ${currentDate.getFullYear()}.`;

const supportEmail = {
  advert: 'support@adwile.com',
  webmaster: 'pub@adwile.com',
};

export const Description = (): JSX.Element => {
  const { i18n } = useTranslation();
  const { pathname } = useLocation();
  const cabinet = getCabinet(pathname);

  const locale = i18n.resolvedLanguage;

  return (
    <div className={cs(styles['wrapper'])}>
      <p dangerouslySetInnerHTML={{ __html: replaceWithBr(copyright) }}></p>
      <p className={cs(styles['paragraph'])}>
        <Trans
          values={{ supportEmail: supportEmail[cabinet] }}
          i18nKey="description.support"
          components={[<a href={`mailto:${supportEmail[cabinet]}`}></a>]}
        />
      </p>
      {locale === 'ru' && (
        <p className={cs(styles['paragraph'])}>
          <Trans
            i18nKey="description.requisites"
            components={[
              <a href="mailto:info@eqwile.com"></a>,
              <a href="tel:+78432533823"></a>,
            ]}
          />
        </p>
      )}
    </div>
  );
};

const getCabinet = (path: string) => {
  if (path.includes('advet')) {
    return 'advert';
  }
  if (path.includes('webmaster')) {
    return 'webmaster';
  }

  return 'advert'; // fallback
};
